module.exports = __webpack_public_path__ + "assets/imgs/logo-simple.png";